import React from 'react'
import { DatePicker } from 'element-react'

const CheckboxSG = () => {
    return (
        <DatePicker
            value={new Date()}
            placeholder="Pick a day"
            format="MM-dd-yyyy"
            onChange={date => {
                this.setState({ value1: date })
            }}
            disabledDate={time => time.getTime() < Date.now()}
        />
    )
}

export default CheckboxSG
